import { MapPin, ArrowRight, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/products";

export default function Hero() {
  return (
    <section id="home" className="relative min-h-[92vh] flex items-center bg-[#071630] overflow-hidden" data-testid="hero-section">
      <img
        src="/assets/hero-editorial.png"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-70"
        data-testid="hero-image"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#071630] via-[#071630]/85 to-[#071630]/30" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="max-w-2xl">
          <p className="reveal text-[#5ec4bc] text-sm font-bold tracking-[0.25em] uppercase mb-6" data-testid="hero-eyebrow">
            {COMPANY.legalName}
          </p>
          <h1
            className="reveal reveal-1 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-white leading-[1.08] mb-6"
            data-testid="hero-headline"
          >
            Toys, Collectibles &amp; Gaming — Explore Your Interests
          </h1>
          <p className="reveal reveal-2 text-base md:text-lg text-[#c7d2e4] leading-relaxed mb-10" data-testid="hero-intro">
            We are a Malaysian retailer based in Sungai Petani, Kedah, focused on EDC toys, games,
            collectibles, video game consoles and hobby products.
          </p>
          <div className="reveal reveal-3 flex flex-wrap gap-4 mb-10">
            <a
              href="#products"
              data-testid="hero-explore-products-btn"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#0d7a72] text-white font-bold text-sm tracking-wide hover:bg-[#0a5f59] transition-colors"
            >
              Explore Products <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href={`https://wa.me/${COMPANY.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/40 text-white font-bold text-sm tracking-wide hover:bg-white/10 transition-colors"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
          </div>
          <p className="reveal reveal-4 inline-flex items-center gap-2 text-sm text-[#9fb2cc]" data-testid="hero-location">
            <MapPin className="w-4 h-4 text-[#5ec4bc]" /> {COMPANY.location}
          </p>
        </div>
      </div>
    </section>
  );
}
